import React from 'react';
import EducatorFiltersDialog from './EducatorFiltersDialog';
import useQuery from '@/pages/educators-engagement/useQuery';

export default function EducatorsEngagementFilterDialog(props) {
  return <EducatorFiltersDialog {...props} useQuery={useQuery} />;
}
